module.exports = __webpack_public_path__ + "static/media/edit.721754c5.svg";